/* 🤖 this file was generated by svg-to-ts */
export const mgcIconProcessRegular: {
  name: 'process-regular';
  data: string;
} = {
  name: 'process-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.477 3.073c-.489.128-.931.47-1.212.941C2.984 4.482 3 4 3.002 12.028c.003 8.068-.017 7.498.279 7.989.167.277.506.601.79.755.414.224.462.227 3.929.227 3.465 0 3.512-.003 3.931-.227.268-.143.698-.573.841-.841.223-.418.227-.474.227-3.841L13 13l3.09-.001c3.367 0 3.423-.004 3.841-.227.268-.143.698-.573.841-.841.224-.419.227-.466.227-3.931 0-3.467-.003-3.515-.227-3.929a2.377 2.377 0 0 0-.755-.79c-.492-.296.083-.276-8.017-.276-6.734 0-7.279.005-7.523.068M11 8v3H5V5h6zm8 0v3h-6V5h6zm-8 8v3H5v-6h6z"/></svg>`
};
